import { ReactNode } from 'react';

import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { selectUserIsClubeBlack } from 'store/selectors';

import { Container, Icon } from './styles';

interface IProps {
  title: string;
  icon: ReactNode;
  link?: string;
  onClick?: () => void;
}

export default function Item({ title, icon, link = '/', onClick }: IProps) {
  const isClubeBlack = useSelector(selectUserIsClubeBlack);

  return (
    <Container onClick={onClick} isClubeBlack={isClubeBlack}>
      <Icon>{icon}</Icon>
      <Link to={link}>{title}</Link>
    </Container>
  );
}
